<template>
	<section class="small-12 flex justify-center recommendedStories border-top">
        <div class="small-12 flex justify-center">
            <h2>Recommended Articles</h2>
        </div>
        <ul class="small-12 large-10 flex float-left">
            <li class="small-12 large-4 columns" v-for="(article, index) in 3" :key="index">
                <article-listing/>
            </li>
        </ul>
    </section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

    // Import the components
    import ArticleListing from '@/components/framework/cards/ArticleListing'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'RecommendedArticles',

		/*
		**  Register the components
		*/

		components: {

			ArticleListing

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>